// Reveals the mobile add-to-cart bar once the main add-to-cart button scrolls above the viewport.
class StickyAtc extends HTMLElement {
  #observer = null;

  connectedCallback() {
    const target = document.querySelector('[data-main-atc]');
    if (!target || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-visible', scrolledPast);
      this.toggleAttribute('inert', !scrolledPast);
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }
}

if (!customElements.get('s-sticky-atc')) customElements.define('s-sticky-atc', StickyAtc);
